import React from 'react'
import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import AvailableFormats from '../../components/cultivars/AvailableFormats'
import FeatureHighlight from '../../components/cultivars/FeatureHighlight'
import Herosection from '../../components/cultivars/Dr/Herosection'
import ProductShowcase from '../../components/cultivars/Dr/ProductShowcase'

const Dr = () => {
  return (
<>
    <Navbar/>
    <Herosection/>
    <FeatureHighlight/>
    <ProductShowcase/>
    <AvailableFormats/>
    <Footer/>
</>  )
}

export default Dr